import React, { FC } from "react";
import styles
  from "../../../components/features/master-plan-modification-portal/modals/modal-reject-krookie/modal-reject-krookie.module.scss";
import errorIcon from "../../../images/error-120.svg";
import Modal from "../../modal/modal";

interface EditAttributesErrorModalProps {
  onClose: () => void;
  message: string;
}
const EditAttributesErrorModal: FC<EditAttributesErrorModalProps> = ({onClose, message}) => {
  return (
    <Modal onClose={onClose}>
      <div className={styles.modalSuccessful}>
        <div className={styles.title}>
          Saving Changes
        </div>
        <div className={styles.body}>
          <img src={errorIcon} alt='error' />
          <div className={styles.description}>{message}</div>
        </div>
      </div>
    </Modal>
  );
};

export default EditAttributesErrorModal;